<template>
  <div class="app-body">
    <div class="left">
      <h2 class="title">云上果园</h2>
      <p class="desc">一个帮助果农管好基地，卖好水果的平台</p>
      <img class="img1" src="@/assets/download-app-1.png">
      <div class="line"></div>
      <div class="qrcode">
        <img src="@/assets/download-app-qrcode.jpg" />
        <span>
          扫一扫或者长按二维码<br />下载云上果园APP
        </span>
      </div>

    </div>
    <div class="right">
      <img src="@/assets/download-app-2.jpeg" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style>
.app-body {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.app-body .left{
  display: flex;
  flex-direction: column;
  flex: 1;
}
.app-body .left .title {
  font-size: 38px;
  color: #333;
  line-height: 85px;
  font-weight: 500;
}
.app-body .left .desc {
  font-size: 26px;
  color: #333333;
  line-height: 30px;
}
.app-body .left .img1 {
  width: 288px;
  height: 83px;
  margin: 18px 0;
}
.app-body .left .line {
  height: 1px;
  width: 288px;
  background-color: #34852F;
}
.app-body .left .qrcode {
  display: flex;
  flex-direction: column;

}
.app-body .left .qrcode img {
  width: 233px;
  height: 233px;
  margin-top: 23px;
  margin-bottom: 14px;
}
.app-body .left .qrcode span {
  display: inline-block;
  width: 233px;
  font-size: 18px;
  color: #999999;
  text-align: center;
}
.app-body .right {
  flex: 1;
}
.app-body .right img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/app.vue